import { render, staticRenderFns } from "./SessionsLiveTableDetail.vue?vue&type=template&id=38ede04a&scoped=true&"
import script from "./SessionsLiveTableDetail.vue?vue&type=script&lang=js&"
export * from "./SessionsLiveTableDetail.vue?vue&type=script&lang=js&"
import style0 from "./SessionsLiveTableDetail.vue?vue&type=style&index=0&id=38ede04a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ede04a",
  null
  
)

export default component.exports